import { Actions, updateActiveDealVisibilityStatus, updateDealSummary } from '@makemydeal/dr-sales-checkin-store';
import type { HostActions } from '@makemydeal/activities-request-proposal';

/**
 * Host-owned effects the activity triggers without owning duplicate action types.
 * Replaces the former string-match contract with sales-checkin-store's own action types.
 */
export const hostActions: HostActions = {
    updateDealSummary,
    setDealAcceptedByBuyer: () => ({
        type: Actions.SET_DEAL_ACCEPTED_BY_BUYER,
        payload: { acceptedByBuyer: true }
    }),
    updateActiveDealVisibilityStatus
};
